import { makeStyles } from '@mui/styles';
const orderFeeStyles = makeStyles(({ palette }) => ({
    container: {
        margin: '12px 0',
        width: '100%',
    },
    primaryContent: {
        color: palette.text.primary,
    },
    secondaryContent: {
        color: palette.text.primary,
    },
    disclaimer: {
        color: palette.text.disabled,
    },
    rowContainer: {},
    secondaryText: {},
}), { name: 'Common_OrderFee' });
export default orderFeeStyles;
//# sourceMappingURL=orderFee.styles.js.map